// Listing photos are uploaded full-size (often 1440px+ JPEG) to Cloudflare R2.
// On the website they go through Netlify Image CDN, which resizes them and
// serves AVIF/WebP. The R2 origin is allow-listed in netlify.toml ([images]).
// Elsewhere (vite dev, the Capacitor app) the original URL is used as-is.

const R2_ORIGIN = /^https:\/\/pub-[0-9a-f]+\.r2\.dev\//;

const cdnAvailable =
  typeof window !== "undefined" &&
  /(^|\.)turaq\.kg$|\.netlify\.app$/.test(window.location.hostname);

/** `width` is in CSS pixels; the CDN gets 2x for sharp images on phones. */
export function thumbUrl(src: string | undefined, width: number): string | undefined {
  if (!src || !cdnAvailable || !R2_ORIGIN.test(src)) return src;
  return `/.netlify/images?url=${encodeURIComponent(src)}&w=${Math.round(width * 2)}&q=70`;
}

/**
 * `srcSet` for a photo shown at up to `widths` CSS pixels (each served at 2x
 * by thumbUrl). Undefined where the CDN isn't there (vite dev, the app) —
 * the plain `src` is used then.
 */
export function photoSrcSet(src: string | undefined, widths: number[]): string | undefined {
  if (!src || !cdnAvailable || !R2_ORIGIN.test(src)) return undefined;
  return widths.map((w) => `${thumbUrl(src, w)} ${w * 2}w`).join(", ");
}

/** Photos under products/wm/ have the «Turaq.kg» mark in the file (server B8) — no CSS label over them. */
export function hasBurnedWatermark(src: string | undefined): boolean {
  return typeof src === "string" && src.includes("/products/wm/");
}
